var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Iconly/Bold/Info Circle") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Bold/Info-Circle",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Info-Circle",
    transform: "translate(2.000100, 1.999300)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,0 C15.53,0 20,4.481 20,10 C20,15.521 15.53,20 10,20 C4.48,20 0,15.521 0,10 C0,4.481 4.48,0 10,0 Z M10,12.931 C9.52,12.931 9.13,13.321 9.13,13.801 C9.13,14.281 9.52,14.681 10.01,14.681 C10.49,14.681 10.88,14.281 10.88,13.801 C10.88,13.321 10.49,12.931 10,12.931 Z M10,5.33 C9.52,5.33 9.12,5.731 9.12,6.21 L9.12,6.21 L9.12,10.63 C9.12,11.111 9.52,11.5 10,11.5 C10.48,11.5 10.87,11.111 10.87,10.63 L10.87,10.63 L10.87,6.21 C10.87,5.731 10.48,5.33 10,5.33 Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/InfoCircle.615af61449427568bef7482c2a70196b.svg";
export { ForwardRef as ReactComponent };